module.exports = __webpack_public_path__ + "static/media/sim.f8310774.png";